@if (initialised) {
  <router-outlet></router-outlet>
}
@if (!initialised) {
  <img class="loader" src="assets/loader.svg" />
}
